import BillingsOrderRailyTaxiCreateRequest, {
  BillingsOrderRailyTaxiCreateRequestBody,
} from "./billings-order-raily-taxi-create.request";

const createBody = (
  request: BillingsOrderRailyTaxiCreateRequest,
): BillingsOrderRailyTaxiCreateRequestBody => {
  return {
    billingNodes: request.billingNodes,
    bonus: request.bonus,
    penalty: request.penalty,
    bonusType: request.bonusType,
    penaltyType: request.penaltyType,
  };
};

const billingsOrderRailyTaxiCreateRequestFactory = {
  createBody,
};

export default billingsOrderRailyTaxiCreateRequestFactory;
